import React from 'react';

const LabelFunction = (props)=>{
    return (
        <div>{props.input.value}</div>
    );    
}; 
export default LabelFunction;